import React,{ useEffect,useState } from 'react';
import * as Yup from 'yup';
import Input from '../Common/Input';
import ReactSelect from '../Common/ReactSelect';
import { useFormik } from 'formik';
import { useNavigate,useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const Update = () => {

    const initialValues = {
        title: '',
        maxDiscount: '',
        discountPercentage: '',
        businessId: 0,
        groupId: 0,
        serviceId: 0,
        subServiceId: 0,
        branchId: 0,
        roleId: 0
    };
    
    const validationSchema = Yup.object({
        title: Yup.string()
        .required(),
        discountPercentage: Yup.number()
        .min(1)
        .max(100)
        .required(),
        maxDiscount: Yup.string()
        .required(),
        businessId: Yup.string()
        .required(),
        groupId: Yup.string()
        .required(),
        serviceId: Yup.string()
        .required(),
        subServiceId: Yup.string()
        .required(),
        branchId: Yup.string()
        .required()
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title,
            maxDiscount: values.maxDiscount,
            discountCode: '',
            discountPercentage: values.discountPercentage,
            subServiceId: values.subServiceId,
            subServiceTitle: '',
            branchId: values.branchId,
            branchTitle: ''
        };
        updateData(postedData).then(({data}) => {
            if(data.status){
                toast.success('به روزرسانی کد تخفیف با موفقیت انجام شد');
                return navigate('/discounts');
            }else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const { id } = useParams();
    const {readData} = useEntityCrud('Discount/GetDiscount?id=' + id);
    const [branchs,setBranchs] = useState([]);
    const {readData: getBranchs} = useEntityCrud('Branch/GetAllBranchs');
    const [roles,setRoles] = useState([]);
    const {readData: getRoles} = useEntityCrud('Role/GetAllRole');
    const [persons,setPersons] = useState([]);
    const {readData: getPersons} = useEntityCrud('Person/GetAllPersons');
    const [businesses,setBusinesses] = useState([]);
    const {readData: getBusiness} = useEntityCrud('Business/GetAllBusiness');
    const [groups,setGroups] = useState([]);
    const {readData: getGroups} = useEntityCrud('Group/GetAllGroups?buisnessId=' + formik.values.businessId);
    const [services,setServices] = useState([]);
    const {readData: getServices} = useEntityCrud('Service/GetAllServices?groupId=' + formik.values.groupId);
    const [subServices,setSubServices] = useState([]);
    const {readData: getSubServices} = useEntityCrud('SubService/GetAllSubServices?serviceId=' + formik.values.serviceId);
    const {addData: updateData} = useEntityCrud('Discount/UpdateDiscount');
    const [oldBranchs,setOldBranchs] = useState([]);
    const navigate = useNavigate();
    
    useEffect(() => {
        getRoles().then(({data}) => {
            let roles = [];
            if(data.status)
                data.result.map(item => {
                    roles.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setRoles(roles);
        })
        getBranchs().then(({data}) => {
            let branchs = [];
            if(data.status)
                data.result.map(item => {
                    branchs.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setBranchs(branchs);
        })
        getBusiness().then(({data}) => {
            let businesses = [];
            if(data.status)
                data.result.map(item => {
                    businesses.push({
                        label: item.title,
                        value: item.id
                    });
                })
            setBusinesses(businesses);
        })
        readData().then(({data}) => {
            if(data.status){
                setOldBranchs(branchs.filter(branch => branch.value == data.result.branchId));
                formik.setValues({
                    ...data.result
                });
            }
        });
    },[]);
    
    useEffect(() => {
        if(formik.values.businessId)
            getGroups().then(({data}) => {
                let groups = [];
                if(data.status)
                    data.result.map(item => {
                        groups.push({
                            label: item.title,
                            value: item.id
                        });
                    })
                setGroups(groups);
            });
    },[formik.values.businessId])

    useEffect(() => {
        if(formik.values.groupId)
            getServices().then(({data}) => {
                let services = [];
                if(data.status)
                    data.result.map(item => {
                        services.push({
                            label: item.title,
                            value: item.id
                        });
                    })
                setServices(services);
            });
    },[formik.values.groupId])

    useEffect(() => {
        if(formik.values.serviceId)
            getSubServices().then(({data}) => {
                let subServices = [];
                if(data.status)
                    data.result.map(item => {
                        subServices.push({
                            label: item.title,
                            value: item.id
                        });
                    })
                setSubServices(subServices);
            });
    },[formik.values.serviceId])

    const handleBack = () => {
        navigate('/branches',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش کد تخفیف</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <ReactSelect label="کسب و کار" formik={formik} options={businesses} required={true} name="businessId" />
                        </div>
                        <div className="col-md-3">
                            <ReactSelect label="گروه" formik={formik} options={groups} required={true} name="groupId" />
                        </div>
                        <div className="col-md-3">
                            <ReactSelect label="سرویس" formik={formik} options={services} required={true} name="serviceId" />
                        </div>
                        <div className="col-md-3">
                            <ReactSelect label="زیر سرویس" formik={formik} options={subServices} required={true} name="subServiceId" />
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-md-3">
                            <Input label="عنوان" name="title" required={true} formik={formik} />
                        </div>
                        <div className="col-md-2">
                            <Input label="درصد تخفیف" name="discountPercentage" required={true} formik={formik} isLtr={true} type="number" max="100" />
                        </div>
                        <div className="col-md-2">
                            <Input label="حداکثر میزان تخفیف" name="maxDiscount" required={true} formik={formik} isLtr={true} type="tel" />
                        </div>
                        <div className="col-md-3">
                            <ReactSelect label="شرکت زیر مجموعه" options={branchs} name="branchId" formik={formik} required={true} value={oldBranchs} />
                        </div>
                        <div className="col-md-2">
                            <ReactSelect label="نقش" options={roles} name="roleId" formik={formik} required={true} />
                        </div>
                    </div>
                    <button className="btn btn-success">ذخیره اطلاعات</button>
                </form>
            </div>
        </div>
    );
}

export default Update;